import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'MEASUREMENT_UNITY';

export default createListReducer(TEMPLATE_NAME);
